import './Brand.scss';

type BrandProps = {
  compact?: boolean;
  inverse?: boolean;
};

export default function Brand({ compact = false, inverse = false }: BrandProps) {
  return (
    <div className={`hub-brand${compact ? ' hub-brand--compact' : ''}${inverse ? ' hub-brand--inverse' : ''}`}>
      <span className="hub-brand-mark" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      {!compact && (
        <span className="hub-brand-copy">
          <strong>Presence</strong>
          <span>Hub</span>
        </span>
      )}
    </div>
  );
}
